const API_BASE = process.env.REACT_APP_API_URL || "http://localhost/api/public";

// dangerouslySetInnerHTML / innerHTML never execute embedded <script> tags,
// so each one must be recreated via document.createElement to actually run
// (this is what GTM/Pixel snippets rely on).
function injectFragment(html, target) {
  if (!html) return;

  const template = document.createElement("template");
  template.innerHTML = html.trim();

  Array.from(template.content.childNodes)
    .reverse()
    .forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === "SCRIPT") {
        const script = document.createElement("script");
        Array.from(node.attributes).forEach((attr) => script.setAttribute(attr.name, attr.value));
        script.text = node.textContent;
        target.prepend(script);
      } else if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.COMMENT_NODE) {
        target.prepend(node.cloneNode(true));
      }
    });
}

export function injectSeoScripts() {
  fetch(`${API_BASE}/config/seo-scripts`)
    .then((res) => (res.ok ? res.json() : null))
    .then((data) => {
      if (!data) return;
      injectFragment(data.head_script, document.head);
      injectFragment(data.body_script, document.body);
    })
    .catch(() => {});
}
